import { TranslationType } from '../components/HbtPortfolioManagementTable/types';
import { requestTypeMapping } from './RequestTypeMapping';

type RequestTypeKey = keyof ReturnType<typeof requestTypeMapping>;

export const getRequestTypeLabel = (
  requestType: RequestTypeKey | string | undefined,
  t: TranslationType
) => {
  const mapping = requestTypeMapping(t);
  return mapping[requestType as RequestTypeKey] ?? requestType ?? '';
};
